import type { DoodFieldType } from './descriptor';

/**
 * CB1 dashboard atoms read their fallback from `options.default`, while block
 * configs declare it on `propertyValue.value`. Without this backfill a prop
 * that was never saved renders empty in the dashboard while the webapp
 * resolver still applies the declared default.
 */
export function backfillLegacyFieldDefault(
  cb1Type: DoodFieldType,
  value: unknown,
  options: Record<string, unknown>,
): void {
  if (options['default'] !== undefined || value === undefined) {
    return;
  }
  if (cb1Type === 'select' || cb1Type === 'radio') {
    options['default'] = value;
    return;
  }
  // `$param` / `$cases` values are resolved at runtime, so only a real boolean
  // can become a static checkbox default.
  if (cb1Type === 'checkbox' && typeof value === 'boolean') {
    options['default'] = value;
  }
}

/**
 * Spreadable `allowed_roles` projection, consumed by the dashboard's
 * `filterFieldsByAllowedRoles`. Left absent rather than empty so descriptors
 * without role restrictions keep their historical shape.
 */
export function legacyAllowedRoles(
  allowedRoles: readonly string[] | undefined,
): { allowed_roles?: string[] } {
  return allowedRoles?.length ? { allowed_roles: [...allowedRoles] } : {};
}
